<template>
    <div class="statistic-data">
      <div class="bg-white p-4 mt-4 rounded-lg">
        <div class="d-lg-flex align-items-center justify-content-md-between">
          <h4 class="text-left mb-4">{{ title }}</h4>
        </div>
        
        <!-- <pre>{{ data }}</pre> -->

        <table class="table table-bordered table-hover">
          <thead class="thead-light">
            <tr>
              <th>Status</th>
              <th>Jumlah</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data" :key="index" :class="`p-2 mb-2 rounded-lg border border-${item.color} text-${item.color} bg-${item.color}`">
                <td v-if="item.icon"><img :src="item.icon" alt="icon" width="24" :class="`rounded-lg border border-${item.color} bg-${item.color}`"/> <strong>{{ item.label }}</strong></td>
              <td><strong>{{ item.value }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RoomStatus',
    props: {
      title: String,
      data: Array,
    },
    setup(props, { emit }) {
      const handleCustom = (value) => {
        emit("show", value)
      }
      return {
        handleCustom
      }
    }
  }
  </script>
  
  <style scoped>
  table {
    width: 100%;
  }
  thead th {
    background-color: #f8f9fa;
  }
  </style>
  